import { PostalCodeInputDesktop } from './Components/Input/PostalCodeInputDesktop'
import { PostalCodeInputMobile } from './Components/Input/PostalCodeInputMobile'

type PostalCodeInputProps = {
  variant: 'desktop' | 'mobile'
}

export function PostalCodeInput({ variant }: PostalCodeInputProps) {
  if (variant === 'mobile') {
    return <PostalCodeInputMobile />
  }

  return <PostalCodeInputDesktop />
}
